import { ResHelper } from '@/helper/ResHelper';

export function localizeWithFallbackKey(key: string, fallbackKey: string): string | undefined {
    return ResHelper.getStringOrUseFallbackKey(key, fallbackKey);
}
